import get from 'lodash.get';

export const selectScreenWidth = (state) => get(state, 'ui.screenWidth', null);
